import { areaRentRatesError } from "./leaseAreaRentValidation.js";

export function areaFootagePatchError(body) {
  if (!body || typeof body !== "object" || Array.isArray(body) || !Object.keys(body).length
    || Object.keys(body).some((key) => !["sizeSf", "usableSizeSf", "rentRates"].includes(key))) {
    return "Only sizeSf, usableSizeSf and rentRates may be edited";
  }
  for (const [key, value] of Object.entries(body)) {
    if (key === "rentRates") {
      const error = areaRentRatesError(value);
      if (error) return error;
      continue;
    }
    if (value !== null && (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > 1000000000)) {
      return `${key} must be a finite number from 0 to 1000000000, or null`;
    }
  }
  return null;
}
